// T72 (Titipan auditor 27 Okt 2026): Master › Tarif Borongan › "Tambahan Rp…" pada kerah yang SUDAH punya
// komponen KERAH dulu mencoba membuat komponen kedua (galat kode ganda). Komponen dicari dulu: dari baris status
// (`komponen_id`), lalu dari daftar komponen yang sudah dimuat (collar_id sama). Baru bila keduanya kosong
// layar membuat komponen baru — dan bila server menjawab "sudah ada", id dari jawaban itu yang dipakai.

/** Komponen KERAH untuk satu baris status kerah: {id, aktif} atau null bila belum ada sama sekali. */
export function cariKomponenKerah(baris, komponen) {
  if (!baris) return null;
  const dariDaftar = (komponen || []).find(
    (k) => k && k.jenis_komponen === "KERAH" && k.collar_id && k.collar_id === baris.collar_id,
  );
  if (baris.komponen_id) {
    const aktif = dariDaftar && dariDaftar.id === baris.komponen_id ? !!dariDaftar.is_active : baris.komponen_aktif !== false;
    return { id: baris.komponen_id, aktif };
  }
  return dariDaftar ? { id: dariDaftar.id, aktif: !!dariDaftar.is_active } : null;
}

/** Jawaban galat server "komponen sudah ada" → {id, aktif}; selain itu null. */
export function komponenDariGalat(e) {
  const d = e && e.response && e.response.data && e.response.data.detail;
  if (!d || typeof d !== "object" || d.error !== "KOMPONEN_SUDAH_ADA" || !d.komponen_id) return null;
  return { id: d.komponen_id, aktif: d.komponen_aktif !== false };
}

// T95 (Owner 1 Nov 2026: "boleh dipikirkan tampilannya yg lebih memudahkan user untuk halaman tsb dan atau
// paginasinya"): status kerah per wilayah — tab wilayah, saringan "Belum ditandai saja", cari, paginasi, aksi massal.
export const PER_HALAMAN_KERAH = 20;

/** Wilayah unik (urut nama) + jumlah kerah belum ditandai per wilayah. */
export function wilayahKerah(items) {
  const m = new Map();
  (items || []).forEach((b) => {
    if (!m.has(b.region_id)) m.set(b.region_id, { region_id: b.region_id, region_name: b.region_name, belum: 0, total: 0 });
    const w = m.get(b.region_id);
    w.total += 1;
    if (b.status === "BELUM_DITANDAI") w.belum += 1;
  });
  return [...m.values()].sort((a, b) => String(a.region_name || "").localeCompare(String(b.region_name || "")));
}

/** Baris satu wilayah, disaring status ("BELUM" | "SEMUA") dan kata cari (nama/kode kerah). */
export function saringKerah(items, { regionId, saring = "BELUM", cari = "" } = {}) {
  const k = String(cari || "").trim().toLowerCase();
  return (items || []).filter((b) => (!regionId || b.region_id === regionId)
    && (saring !== "BELUM" || b.status === "BELUM_DITANDAI")
    && (!k || String(b.collar_name || "").toLowerCase().includes(k) || String(b.collar_code || "").toLowerCase().includes(k)));
}

/** Potongan satu halaman + jumlah halaman (halaman di luar jangkauan dijepit). */
export function halamanKerah(rows, halaman, per = PER_HALAMAN_KERAH) {
  const jumlah = Math.max(1, Math.ceil((rows || []).length / per));
  const h = Math.min(Math.max(1, halaman || 1), jumlah);
  return { rows: (rows || []).slice((h - 1) * per, h * per), halaman: h, jumlah };
}

/** Kalimat dialog konfirmasi aksi massal — menyebut jumlah DAN nama kerah (pagar salah pencet). */
export function kalimatTandaiMassal(baris) {
  const nama = (baris || []).map((b) => b.collar_name);
  const w = [...new Set((baris || []).map((b) => b.region_name))].join(", ");
  return `Tandai ${nama.length} kerah di ${w} "tanpa tambahan" mulai hari ini: ${nama.join(", ")}? `
    + "FA berkerah itu tidak mendapat upah tambahan kerah.";
}
